import React from 'react'
import { Show, TabbedShowLayout, NumberField, ReferenceField, TextField, Tab } from 'react-admin'

const AvailabilitysTagShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="summary">
        <NumberField source="position" />
        <TextField source="label" />
        <ReferenceField source="client.id" reference="clients">
          <TextField source="name" />
        </ReferenceField>
      </Tab>
    </TabbedShowLayout>
  </Show>
)

export default AvailabilitysTagShow
